 
import React from 'react';
import { motion } from 'framer-motion';

const LandingSection: React.FC = () => {
  return (
    <section className="h-screen w-full relative overflow-hidden bg-gradient-to-br from-darkbrown via-charcol to-darkbrown">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/images/bg.jpg" 
          alt="Medical background" 
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-darkbrown/80 via-darkbrown/60 to-darkbrown/90" />
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 z-0">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 rounded-full bg-palegold/20"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              opacity: [0.2, 0.5, 0.2],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              ease: "easeInOut",
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="relative z-10 h-full container mx-auto px-4">
        <div className="h-full flex items-center justify-center">
          <div className="w-full lg:w-2/3 text-center">
            {/* Tagline */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="mb-6"
            >
              <span className="text-golden-yellow text-lg md:text-xl font-medium tracking-wider">
                ADVANCING SURGICAL EXCELLENCE
              </span>
            </motion.div>

            {/* Main Heading */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="mb-8"
            >
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold">
                <span className="block text-softwhite mb-2">Dr. Hirak</span>
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-earthybeige to-palegold">
                  Pahari
                </span>
              </h1>
            </motion.div>

            {/* Description */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="relative mb-12"
            >
              <p className="text-xl md:text-2xl text-sage leading-relaxed mx-auto max-w-2xl">
                Leading innovations in liver transplant and hepatobiliary surgery, bringing new hope to patients.
              </p>
            </motion.div>

            {/* CTA Button */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex justify-center"
            >
              <button className="px-8 py-4 bg-gradient-to-r from-golden-yellow to-palegold text-darkbrown rounded-lg 
                               font-medium transform transition-all duration-200 hover:scale-105 hover:shadow-lg
                               hover:shadow-golden-yellow/25">
                Schedule Consultation
              </button>
            </motion.div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <div className="w-1 h-12 bg-gradient-to-b from-golden-yellow/0 via-golden-yellow/50 to-golden-yellow/0" />
        </motion.div>
      </div>
    </section>
  );
};

export default LandingSection;